import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Overview = () => {
  return (
    <Card className="m-6 shadow-md">
      <CardHeader>
        <CardTitle>Overview</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-center h-96">
          <h2 className="text-2xl font-semibold text-muted-foreground">Overview</h2>
        </div>
      </CardContent>
    </Card>
  );
};

export default Overview;